import type { AccordionProps } from "@op/puck-types";
import { Dc_Text_Toggle } from "@op/sf-op";

const Accordion = ({ heading, children }: AccordionProps) => {
  return <Dc_Text_Toggle triggerText={heading}>{children}</Dc_Text_Toggle>;
};

export default Accordion;
